import { __module as t } from "../../../_virtual/isDivisibleBy.js";
import { a as e } from "./util/assertString.js";
import { t as r } from "./toFloat.js";
!function (t, o) {
  Object.defineProperty(o, "__esModule", {
    value: !0
  }), o.default = function (t, e) {
    return (0, s.default)(t), (0, a.default)(t) % parseInt(e, 10) == 0;
  };
  var s = i(e),
    a = i(r);
  function i(t) {
    return t && t.__esModule ? t : {
      default: t
    };
  }
  t.exports = o.default, t.exports.default = o.default;
}(t, t.exports);
var o = t.exports;
export { o as i };